import {Injectable} from '@angular/core';
import {RefDataItem, RefDataType} from '../../shared/data-objects/ref-data-item';
import {Observable} from 'rxjs/Observable';
import {ServiceBase} from './service-base';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

@Injectable()
export class RefDataService extends ServiceBase {

  serviceSize:any


  public static get refDataUrl(): string {
    return ServiceBase.baseHref + '/refData';
  }
  public static get psaServiceSizeDataUrl(): string {
    return ServiceBase.baseHref + '/api/serviceSize/';
  }
  public static get  pumpCurveDataUrl(): string {
    return ServiceBase.baseHref + '/api/pumpCurve/';
  }
  public static get waterSupplyDataUrl(): string {
    return ServiceBase.baseHref + '/api/waterSupplyOptions/';
  }
  public static get refDataPublicHolidaysUrl() {
    return ServiceBase.baseHref + '/api/refData/publicHolidays';
  }


  constructor(private http: HttpClient) {
    super();
  }

  retrieveReferenceData(refDataType: RefDataType, token: string): Observable<RefDataItem[]> {
    const refDataTypeParam: string = RefDataType[refDataType];
    const params: HttpParams = new HttpParams().set('refDataType', refDataTypeParam);
    const header: HttpHeaders = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + token);
    return this.http.get<RefDataItem[]>(RefDataService.refDataUrl, {headers: header, params: params});
  }


  retrievePsaServiceData(token: string): Observable<any[]> {
    const header: HttpHeaders = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + token);
    return this.http.get<any[]>(RefDataService.psaServiceSizeDataUrl, {headers: header});
  }

  retrievePumpCurveData(token: string): Observable<any[]> {
    const header: HttpHeaders = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + token);
    return this.http.get<any[]>(RefDataService.pumpCurveDataUrl, {headers: header});
  }

  retrieveWaterSupplyData(token: string): Observable<any[]> {
    const header: HttpHeaders = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + token);
    return this.http.get<any[]>(RefDataService.waterSupplyDataUrl, {headers: header});
  }

  publicHolidays(appType: string, token: string) {
    const header: HttpHeaders = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + token);
    return this.http.get<any[]>(`${RefDataService.refDataPublicHolidaysUrl}?app=${appType}`, {headers: header});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/ref-data.service.ts